var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { ADD_CUSTOM_FIELD } from "../../../constants";
import { useCustomFieldActions } from "../../../hooks/actions/useCustomFieldActions";
import { CustomFieldsContext } from "../../../providers/CustomFieldsContextProvider";
import { CustomFieldType } from "../../../types/custom-field";
import { WPQTIconButton } from "../../common/Button/Button";
import { WPQTInput } from "../../common/Input/Input";
import { WPQTSelect } from "../../common/Select/WPQTSelect";
import { WPQTTextarea } from "../../common/TextArea/TextArea";
function CustomFieldCreation({ description }) {
    const [customFieldName, setCustomFieldName] = useState("");
    const [customFieldDescription, setCustomFieldDescription] = useState("");
    const [isCreationOpen, setIsCreationOpen] = useState(false);
    const [selectedCustomFieldType, setSelectedCustomFieldType] = useState(CustomFieldType.Text);
    const { addCustomField } = useCustomFieldActions();
    const { state: { entityId, entityType }, customFieldsDispatch, } = useContext(CustomFieldsContext);
    const [loading, setLoading] = useState(false);
    const customFieldTypeOptions = [
        { value: CustomFieldType.Text, label: "Text" },
        { value: CustomFieldType.Checkbox, label: "Checkbox" },
    ];
    const createCustomField = () => __awaiter(this, void 0, void 0, function* () {
        if (!entityId || !entityType) {
            console.error("Entity ID or Entity Type is missing");
            return;
        }
        setLoading(true);
        yield addCustomField(entityId, entityType, selectedCustomFieldType, customFieldName, customFieldDescription, (newCustomField) => {
            customFieldsDispatch({
                type: ADD_CUSTOM_FIELD,
                payload: newCustomField,
            });
            resetState();
        });
        setLoading(false);
    });
    const resetState = () => {
        setCustomFieldName("");
        setCustomFieldDescription("");
        setSelectedCustomFieldType(CustomFieldType.Text);
        setIsCreationOpen(false);
    };
    return (_jsxs("div", { className: "wpqt-mb-6 wpqt-flex wpqt-flex-col wpqt-items-center", children: [_jsx("h2", { children: __("Custom Fields", "quicktasker") }), _jsx("div", { className: "wpqt-mb-4 wpqt-text-center", children: description }), isCreationOpen && (_jsxs("div", { className: "wpqt-flex wpqt-gap-4", children: [_jsxs("div", { children: [_jsx("div", { className: "wpqt-mb-2", children: __("Name", "quicktasker") }), _jsx(WPQTInput, { value: customFieldName, onChange: setCustomFieldName })] }), _jsxs("div", { children: [_jsx("div", { className: "wpqt-mb-2", children: __("Description", "quicktasker") }), _jsx(WPQTTextarea, { value: customFieldDescription, onChange: setCustomFieldDescription })] }), _jsxs("div", { children: [_jsx("div", { className: "wpqt-mb-2", children: __("Type", "quicktasker") }), _jsx(WPQTSelect, { selectedOptionValue: selectedCustomFieldType, options: customFieldTypeOptions, onSelectionChange: (selection) => {
                                    setSelectedCustomFieldType(selection);
                                }, allSelector: false })] })] })), _jsxs("div", { className: "wpqt-flex wpqt-justify-end wpqt-gap-3", children: [_jsx(WPQTIconButton, { text: isCreationOpen
                            ? __("Cancel", "quicktasker")
                            : __("Add new custom field", "quicktasker"), onClick: () => setIsCreationOpen(!isCreationOpen), icon: isCreationOpen ? (_jsx(XCircleIcon, { className: "wpqt-icon-red wpqt-size-5" })) : (_jsx(PlusCircleIcon, { className: "wpqt-icon-green wpqt-size-5" })) }), isCreationOpen && (_jsx(WPQTIconButton, { text: __("Add", "quicktasker"), onClick: createCustomField, loading: loading, icon: _jsx(PlusCircleIcon, { className: "wpqt-icon-green wpqt-size-5" }) }))] })] }));
}
export { CustomFieldCreation };
